/**
 * The one step the phone is waiting on.
 *
 * Two moments in the morning leave no trace to detect: the faregates, and a train pulling out of
 * an underground platform. The progress line can already declare them, but it asks for a step to
 * be found on a horizontally scrolling row — which is a lot to ask of someone walking onto a
 * platform. So when the journey is one step from a moment nobody can observe, that step gets a
 * button: always in the same place, always in reach, gone once it is no longer the question.
 *
 * Held rather than tapped, which is what makes it safe to show at all. It is laid *over* the
 * progress line and unmounts on commit, so a tap here handed the next press straight to the line
 * underneath — which is how a second press two seconds later put Eben back on the platform he had
 * just left. `DECLARE_SETTLE_MS` closes the same gap from the other side.
 */

import { DECLARE_LABELS, nextDeclarablePhase } from "../../core/rider-journey";
import type { RiderPhase } from "../../shared/types";
import { HoldButton } from "./HoldButton";

const HAZE_LAYERS = [0, 1, 2, 3];

export function NextStepButton({
	phase,
	phases,
	onDeclare,
}: {
	phase: RiderPhase;
	phases: RiderPhase[];
	onDeclare: (phase: RiderPhase) => void;
}) {
	const next = nextDeclarablePhase(phase, phases);
	const label = next ? DECLARE_LABELS[next] : null;
	if (!next || !label) {
		return null;
	}
	return (
		<div className="nextstep">
			{HAZE_LAYERS.map((layer) => (
				<div key={layer} className="nextstep__haze" data-layer={layer} aria-hidden="true" />
			))}
			<HoldButton label={label} actionLabel={label} phase={next} className="nextstep__button" onConfirm={() => onDeclare(next)} />
		</div>
	);
}
